module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAASUlEQVRYw2Nwav3SAMT/Bwg3MAyg5WA86oBRB4w6AKcDqA2GngNG08BoGhhNA6NpYDQNUCuIh64DRtPAqANGHTDqAHo6YEC75wDdjZvK7JI72wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/doc.png
// module id = 1610
// module chunks = 0